const dataWork = [
    {
        id: 1,
        numb: '01',
        title: '10,000 Chimps',
        text : 'A full PFP and digital art collection living as Bitcoin Ordinals.',
        active: 'active'
    },
    {
        id: 2,
        numb: '02',
        title: 'Clear supply plan',
        text : 'A small reserve supports the team, future activations, and community rewards.',
        active:'active'
        
       
    },

    {
        id: 3,
        numb: '03',
        title: "Public access",
        text : 'The launch is built for open participation, with promotional giveaways for early supporters.',
        active:'active'
    },
    {
        id: 4,
        numb: '04',
        title: "Satflow",
        text : 'Primary marketplace activity is centered on Satflow, with room to expand after launch.',
        active:'active'
    },
]
export default dataWork;
